module.exports = __webpack_public_path__ + "img/list-status.a875b4f6.svg";